const ALIGNMENT_FIELD_IDS = new Set(["aboveBelow0000", "aboveBelow0830"]);

function addUnique(options, value) {
  const normalized = String(value || "").trim();
  if (!normalized || normalized === "Any" || options.includes(normalized)) return;
  options.push(normalized);
}

export function normalizeTradeEnvValueForAnalytics(value, fieldDef = {}) {
  if (value === undefined || value === null || value === "") return "N/A";

  if (ALIGNMENT_FIELD_IDS.has(fieldDef.id)) {
    if (value === true || value === "true" || value === "above" || value === "Aligned") return "Aligned";
    if (value === false || value === "false" || value === "below" || value === "Not Aligned") return "Not Aligned";
    return "N/A";
  }

  if (fieldDef.fieldType === "yesNoNA" || !fieldDef.fieldType) {
    if (value === true || value === "true" || value === "Yes") return "Yes";
    if (value === false || value === "false" || value === "No") return "No";
  }

  const normalized = String(value).trim();
  return normalized || "N/A";
}

export function getTradeEnvSelectOptions(fieldDef = {}, trades = []) {
  const options = [];

  if (ALIGNMENT_FIELD_IDS.has(fieldDef.id)) {
    ["Aligned", "Not Aligned"].forEach((value) => addUnique(options, value));
  } else if (fieldDef.fieldType === "dropdown") {
    (fieldDef.options || []).forEach((value) => addUnique(options, value));
  } else {
    ["Yes", "No"].forEach((value) => addUnique(options, value));
  }

  const observed = trades
    .map((trade) => normalizeTradeEnvValueForAnalytics(trade?.[fieldDef.id], fieldDef))
    .filter((value) => value !== "N/A")
    .sort((a, b) => a.localeCompare(b));

  observed.forEach((value) => addUnique(options, value));
  addUnique(options, "N/A");
  return options;
}

export function isTextTradeEnvField(fieldDef = {}) {
  return fieldDef.fieldType === "text";
}
